import { gql } from '@apollo/client';

const UserListInfoShared = gql`
  fragment UserListInfoShared on User {
    id
    firstName
    lastName
    email
    phone
    state
    withoutPlan
    legacyId
    partnerLocation {
      id
      name
    }
    account {
      id
      accountNumber
    }
    lastLoginAt
    createdAt
  }
`;

export default UserListInfoShared;
